import { render, staticRenderFns } from "./VetSubsidiaries.vue?vue&type=template&id=32d0676c&scoped=true"
import script from "./VetSubsidiaries.vue?vue&type=script&lang=js"
export * from "./VetSubsidiaries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d0676c",
  null
  
)

export default component.exports